import * as React from 'react';
import classnames from 'classnames';

import styles from './styles.module.css';

export interface AboutIntroProps {
  className?: string;
}

/**
 * @name AboutIntro
 * @description First section of the about page with a bold image and
 * header. The responsiveness of this and the beginning of the "gray" copy
 * is handled by the css.
 */
export const AboutIntro = (props: AboutIntroProps) => {
  const { className } = props;

  // Styles
  const tailwind = 'ui-container-lg relative';
  const cssComponent = classnames(styles.component, className);
  const cssContainer = classnames(tailwind, styles.container);

  return (
    <div className={cssComponent}>
      <div className={cssContainer}>
        <h1 className={styles.heading}>
          It all started when a friend said{' '}
          <span className="text-pine">“I can’t handle Seph*ra”</span>
        </h1>
        <img
          alt=""
          className={styles.image}
          src="/images/rebrand/about-us.svg"
        />
        <p className="mt-2x p-2x md:block md:px-0">
          She was looking for a moisturizer and was intimidated by the 3,716
          options. I sent her a list of my fav products. She later sent them to
          a friend, who told her friend, who told her friend and soon I had 300
          people emailing me back and forth for skincare recommendations. And I
          was just a woman in my PJs, responding from my Gmail account.
        </p>
      </div>
    </div>
  );
};
